import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { AppSettings } from '../../app.constant';
import { ProgramService } from '../../shared/services/program.service';
import { ProgramTableComponent } from '../../private/tables/program-table/program-table.component';
import { InstitutionService } from 'src/app/shared/services/institution.service';

@Component({
  selector: 'program',
  templateUrl: './program.component.html',
  styleUrls: ['./program.component.css']
})
export class ProgramComponent implements OnInit {
  programform: FormGroup;
  httpResponseMessage: any;
  submitted = false;
  post: any;
  errorMessage: String;
  programentity: any;
  institutions: any;
  ProgramName: string = '';
  PK_ProgramID: any = '';
  ProgramCode: any = '';
  Duration: any = '';
  FK_InstitutionID: any = '';
  buttonTitle: String = 'S A V E ';
  newtitle: String = " N E W ";

  @ViewChild(ProgramTableComponent) categorytable;
  constructor(
    private formbuilder: FormBuilder,
    private _programservice: ProgramService,
    private _institutionService: InstitutionService,
    private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.getAllInstitution();
    this.programform = this.formbuilder.group({
      'PK_ProgramID': [''],
      'ProgramCode': ['', [Validators.required, Validators.maxLength(10)]],
      'ProgramName': ['', [Validators.required, Validators.maxLength(200)]],
      'Duration': ['', [Validators.required, Validators.maxLength(10)]],
      'FK_InstitutionID': [Validators.required],
    })
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.programform.controls[controlName].hasError(errorName);
  }

  receiveData($event) {
    this.programentity = $event
    this.ProgramName = this.programentity[0].ProgramName;
    this.PK_ProgramID = this.programentity[0].PK_ProgramID;
    this.ProgramCode = this.programentity[0].ProgramCode;
    this.Duration = this.programentity[0].Duration;
    this.FK_InstitutionID = this.programentity[0].FK_InstitutionID;
  }

  getAllInstitution(): void {
    this._institutionService.getAllInstitution(AppSettings.API_ENDPOINT + AppSettings.GetAllInstitution).subscribe(
      data => {
        this.institutions = data;

      },
      error => this.errorMessage = <any>error)
  }

  postProgram(post): void {
    if (post.PK_ProgramID != '' && post.PK_ProgramID != null) {
      this.updateProgram(post);
    }
    else {
      this.createProgram(post);
    }
  }

  createProgram(post): void {
    this.submitted = true;
    if (this.programform.invalid) { return; }
    this.post = JSON.stringify(post);

    this._programservice.postProgram(AppSettings.API_ENDPOINT + AppSettings.CreateProgram, this.post).subscribe(
      data => {
        this.httpResponseMessage = data;
        this.programform.reset();
        this.openSnackBar(this.httpResponseMessage, '');
      },
      error => this.errorMessage = <any>error)
  }

  updateProgram(post) {
    if (this.programform.invalid) {
      return;
    }
    this.post = JSON.stringify(post);
    this._programservice.updateProgram(AppSettings.API_ENDPOINT + AppSettings.UpdateProgram, this.post).subscribe(
      data => {
      this.httpResponseMessage = data;
        this.programform.reset();
        this.openSnackBar(this.httpResponseMessage, '');
      },
      error => this.errorMessage = <any>error)
  }

  cleardata() {
    this.programform.reset();
  }

  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }
}

